import { LatLng, Layer } from 'leaflet';
import { DrawPolygon } from '../components/DrawControl.models/Draw.polygon';
import { AddVerticesCommandBase } from './addVerticesCommandBase';

export class AddPolygonVerticesCommand extends AddVerticesCommandBase {
  public polygon: DrawPolygon;
  constructor(polygon: DrawPolygon, latlng: LatLng) {
    super(latlng);
    this.polygon = polygon;
  }

  executeUndo(): void {
    if (this.polygon._markers.length === this.latlng.length) {
      this.polygon.disable();
      this.polygon.enable();
      return;
    }

    this.polygon._markers = this.polygon._markers.slice(0, this.polygon._poly._latlngs.length - this.latlng.length);
    this.polygon._poly.setLatLngs(this.polygon._poly._latlngs.slice(0, this.polygon._poly._latlngs.length - this.latlng.length));

    if (this.polygon._poly.getLatLngs().length < 2) {
      this.polygon._map.removeLayer(this.polygon._poly as unknown as Layer);
    }

    this.polygon._vertexChanged(this.latlng.at(-1) as LatLng, false);

    this.polygon._updateGuide();
  }

  executeRedo(): void {
    this.polygon._markers.push(this.polygon._createMarker(this.latlng.at(-1) as LatLng));
    this.polygon._poly.setLatLngs([...this.polygon._poly._latlngs, ...this.latlng]);

    const polyLayer = this.polygon._poly as unknown as Layer;

    if (!this.polygon._map.hasLayer(polyLayer)) {
      this.polygon._map.addLayer(polyLayer);
    }

    this.polygon._vertexChanged(this.latlng.at(-1) as LatLng, true);

    this.polygon._updateGuide();
  }
}
